import {
  Project,
  Proposal,
  Prestation,
  GenericalResponse,
  ResponseTypes
} from "./state";
import {
  submitCurrentResponse,
  fetchProposalByUuid,
  fetchPrestationById
} from "src/api/projects";

export const ADD_PROJECTS = "ADD_PROJECTS";
export const UPDATE_PROJECT_STATS_AND_ACTIONS =
  "UPDATE_PROJECT_STATS_AND_ACTIONS";
export const ADD_ARCHIVED_PROJECTS = "ADD_ARCHIVED_PROJECTS";
export const ADD_PROJECT_PRESTATIONS = "ADD_PROJECT_PRESTATIONS";
export const ADD_PRESTATION_PROPOSALS = "ADD_PRESTATION_PROPOSALS";
export const UPDATE_PROPOSAL = "UPDATE_PROPOSAL";

export const START_LOADING_PROJECTS = "START_LOADING_PROJECTS";

export const START_LOADING_PRESTATIONS = "START_LOADING_PRESTATIONS";
export const START_LOADING_PROPOSALS = "START_LOADING_PROPOSALS";

/**
 * Add projects to existing project array
 */
export function addProjects(projects: Project[]) {
  return { type: ADD_PROJECTS as typeof ADD_PROJECTS, projects };
}

export function updateProjectStatsAndActions(
  projectId: number,
  responseType: ResponseTypes,
  proposalUuid: string
) {
  return {
    type: UPDATE_PROJECT_STATS_AND_ACTIONS as typeof UPDATE_PROJECT_STATS_AND_ACTIONS,
    projectId,
    responseType,
    proposalUuid
  };
}

/**
 * Add prestations to project
 */
export function addProjectPrestations(
  projectId: number,
  prestations: Prestation[]
) {
  return {
    type: ADD_PROJECT_PRESTATIONS as typeof ADD_PROJECT_PRESTATIONS,
    projectId,
    prestations
  };
}

/**
 * Add proposals to a prestation
 */
export function addPrestationProposals(
  projectId: number,
  prestationId: number,
  proposals: Proposal[]
) {
  return {
    type: ADD_PRESTATION_PROPOSALS as typeof ADD_PRESTATION_PROPOSALS,
    projectId,
    prestationId,
    proposals
  };
}

/**
 * Add a response for POV proposals
 */
export function updateProposal(
  projectId: number,
  prestationId: number,
  proposalUuid: string,
  proposal: Proposal
) {
  return {
    type: UPDATE_PROPOSAL as typeof UPDATE_PROPOSAL,
    projectId,
    prestationId,
    proposalUuid,
    proposal
  };
}

export function submitResponse(
  projectId,
  prestationId,
  proposal: Proposal,
  response: GenericalResponse,
  // share is use when you share a proposal
  share?: boolean
) {
  return async dispatch => {
    await submitCurrentResponse(response, proposal);
    // Reload project stats
    dispatch(
      updateProjectStatsAndActions(
        projectId,
        response.responseType,
        proposal.uuid
      )
    );
    // retrieve a proposal after a submit response because the proposal status can change
    const reloadedProposal = await fetchProposalByUuid(proposal.uuid);

    // Retrieve prestation because it's status can change
    const prestation = await fetchPrestationById(projectId, prestationId);

    dispatch(
      updateProposal(projectId, prestationId, proposal.uuid, reloadedProposal)
    );
    if (!share) {
      dispatch(addProjectPrestations(projectId, [prestation]));
    }
  };
}

/**
 * Set isLoading projects to true
 */
export function startLoadingProjects() {
  return { type: START_LOADING_PROJECTS as typeof START_LOADING_PROJECTS };
}

/**
 * Start loading prestations of a given project
 */
export function startLoadingPrestations(projectId: number) {
  return {
    type: START_LOADING_PRESTATIONS as typeof START_LOADING_PRESTATIONS,
    projectId
  };
}

/**
 * Start loading proposals of a given prestation
 */
export function startLoadingProposals(projectId: number, prestationId: number) {
  return {
    type: START_LOADING_PROPOSALS as typeof START_LOADING_PROPOSALS,
    projectId,
    prestationId
  };
}

export type Actions =
  | ReturnType<typeof addProjects>
  | ReturnType<typeof updateProjectStatsAndActions>
  | ReturnType<typeof addProjectPrestations>
  | ReturnType<typeof updateProposal>
  | ReturnType<typeof addPrestationProposals>
  | ReturnType<typeof startLoadingProjects>
  | ReturnType<typeof startLoadingPrestations>
  | ReturnType<typeof startLoadingProposals>;



// WEBPACK FOOTER //
// ./src/redux/projects/actions.ts